import branchCollectionItemModelValidator from './branchCollectionItem';

export default branchCollectionItemModelValidator;
